import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import autoBind from 'react-autobind'
import { browserHistory } from 'react-router'
import getMuiTheme from 'material-ui/styles/getMuiTheme'
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme'
import TextField from 'material-ui/TextField'
import RaisedButton from 'material-ui/RaisedButton'
import { cyan900, cyan500 } from 'material-ui/styles/colors'
import DialogModal from '../home/DialogModal'
import _ from 'lodash'

const propTypes = {
  onSave: PropTypes.func,
  onDelete: PropTypes.func.isRequired,
  article: PropTypes.object,
};

class EditArticle extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogTitle: ' ',
      dialogMessage: ' ',
      dialogActionTitle: ' ',
      required: {
        title: null,
        slug: null,
        contents: null,
      },
      article: {
        altText: '',
        contents: '',
        image: '',
        slug: '',
        summary: '',
        thumbnail: '',
        title: '',
      },
      open: false,
      edited: false,
      viewRedirect: false,
      assignedOnly: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.article) {
      this.setState({ article: nextProps.article });
    }
    this.setRequiredParams();
  }
  setRequiredParams() {
    const { article, required} = this.state
    Object.keys(required).forEach((paramName) => {
      const param = article[paramName];
      required[paramName] = (param == null || param.length === 0 || param === 0) ? 'This field is required' : null;
    });
    this.setState({ required });
  }
  handleChange(e) {
    const { article } = this.state;
    if (e.target.type === 'checkbox') {
      _.set(article, e.target.name, e.target.checked);
    } else {
      _.set(article, e.target.name, e.target.value);
    }
    this.setState({
      article,
      edited: true,
    });
    this.setRequiredParams();
  }
  handleClose() {
    this.setState({
      open: false,
      edited: false,
      viewRedirect: false,
    })
    browserHistory.push(`/articles`);

  }
  handleDeleteOpen() {
    const nextState = this.state;
    nextState.dialogTitle = 'Delete Article';
    nextState.dialogMessage = 'Do you really want to delete this article?';
    nextState.dialogActionTitle = 'Delete';
    nextState.open = true;
    nextState.delete = true;
    this.setState({ nextState });
  }
  handleOpen() {
    const nextState = this.state;
    nextState.dialogTitle = 'Save Campaign Changes';
    nextState.dialogMessage = 'Do you really want to save the changes in this campaign?';
    nextState.dialogActionTitle = 'Save';
    nextState.open = true;
    this.setState({ nextState });
  }
  saveChanges() {
    this.setState({
      open: false,
      edited: false,
      viewRedirect: false,
    });
    switch (true) {
      case (this.state.delete):
        this.props.onDelete(this.state.article);
        break;
      case (this.state.edited && this.state.viewRedirect):
        this.props.onView(this.state.article)
        break;
      default:
        this.props.onSave(this.state.article)
        break;
    }
  }
  handleCancel() {
    browserHistory.push('/articles');
  }
  render() {
    const { article, required} = this.state
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '2%',
        width: '250px',
      },
      inputStyleMid: {
        marginRight: '2%',
        width: '100%',
        maxWidth: '500px'
      },
      inputStyleLong: {
        marginRight: '2%',
        width: '100%',
      },
    };
    return (
      <div style={{ width: '100%' }}>
        <h2>Edit Article</h2>
        <div className="content">
          <DialogModal
            dialogOpen={this.state.open}
            dialogHandleClose={this.handleClose}
            dialogHandleSubmit={() => this.saveChanges()}
            dialogTitle={this.state.dialogTitle}
            dialogMessage={this.state.dialogMessage}
            dialogActionTitle={this.state.dialogActionTitle}
          />
          <div className="float-right">
            <RaisedButton
              label="Cancel"
              style={{ marginRight: '10px' }}
              primary
              onClick={this.handleCancel}
            />
            <RaisedButton
              style={{ marginRight: '10px' }}
              label="Delete"
              primary
              onClick={this.handleDeleteOpen}
            />
            <RaisedButton
              label="Save"
              primary
              onClick={this.handleOpen}
            />
          </div>
          <br />
          <TextField
              floatingLabelText="Title"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={article.title}
              name="title"
              onChange={this.handleChange}
              style={styles.inputStyle}
              errorText={required.title}
              errorStyle={{ color: cyan500 }}
            />
            <TextField
              floatingLabelText="Slug"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={article.slug}
              name="slug"
              onChange={this.handleChange}
              style={styles.inputStyle}
              errorText={required.slug}
              errorStyle={{ color: cyan500 }}
            />
            <br />
            <br />
            <TextField
              floatingLabelText="Contents"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={article.contents}
              name="contents"
              onChange={this.handleChange}
              style={styles.inputStyleMid}
              errorText={required.contents}
              errorStyle={{ color: cyan500 }}
              multiLine={true}
            />
            <TextField
              floatingLabelText="Summary"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={article.summary}
              name="summary"
              onChange={this.handleChange}
              style={styles.inputStyleMid}
              multiLine={true}
            />
            <TextField
              floatingLabelText="Image Url"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={article.image}
              name="image"
              onChange={this.handleChange}
              style={styles.inputStyleLong}
            />
            <TextField
              floatingLabelText="Thumbnail"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={article.thumbnail}
              name="thumbnail"
              onChange={this.handleChange}
              style={styles.inputStyleLong}
            />
            <TextField
              floatingLabelText="Alt Text"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={article.altText}
              name="altText"
              onChange={this.handleChange}
              style={styles.inputStyle}
            />
          <br />  
        </div>
      </div>
    );
  }
}

EditArticle.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

EditArticle.propTypes = propTypes;


export default connect()(EditArticle);



// WEBPACK FOOTER //
// ./src/components/Articles/EditArticles.js